'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'uniform-martial-arts';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e3d1';
var svgPathData = 'M180 0l37.6 0c12.3 0 23.5 7 28.8 18.1l61.1 126.7-54.6 143.3-109 0 0-154.9-46 83.7c-1.3 2.4-2 5-2 7.7L96 384c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7c15.7-28.5 44.6-47 76.7-49.5 1-.2 2-.3 3-.3l20 0zM389.1 20.6C393.8 8.2 405.7 0 419 0l61 0c1 0 2 .1 3 .3 32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54L640 384c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-159.6c0-2.7-.7-5.3-2-7.7l-46-83.7 0 154.9-208.8 0c35.7-93.7 69.7-182.9 101.9-267.4zM320 320l176 0 0 32-146.1 0 47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l47.4-71.1-146.1 0 0-32 176 0zM216.1 405.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3l24.1-36.1 24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6l-14.2-21.4 86.3 0 0 64c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 86.3 0-14.2 21.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUniformMartialArts = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;